import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_AUDIT_LIST } from "../services/get-all-audits";
import { GET_REPORT_PACKAGE_LIST } from "../services/get-report-package-list";
import { cloneDeep, cloneDeepWith, isEqual } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";
import { refreshExternalAuditList } from "../component";
import { HIDE_LOADER } from "../../../../common_components/mdae-common-reducer";
import { AUDIT_LIST_TYPE } from "../../../emdr-inbox/constant";
export const SET_HEADER_RANGE_FILTER_COUNT = "SET_HEADER_RANGE_FILTER_COUNT";
export const TOGGLE_AUDIT_LIST_ACTION_POPOVER =
  "TOGGLE_AUDIT_LIST_ACTION_POPOVER";
export const SET_AUDIT_DATAGRID_FILTER =
  "SET_AUDIT_DATAGRID_FILTER";
export const TOGGLE_DOCUMENT_MANAGEMENT_POPUP = "TOGGLE_DOCUMENT_MANAGEMENT_POPUP";
export const SET_EXTERNAL_AUDIT_PROPERTIES = "SET_EXTERNAL_AUDIT_PROPERTIES";
export const TOGGLE_VIEW_REPORT_POPUP = "TOGGLE_VIEW_REPORT_POPUP";
export const TOGGLE_REPORT_PARAMETER_POPUP="TOGGLE_REPORT_PARAMETER_POPUP";
export const CURRENT_REPORT_PARAMETER_OBJECT="CURRENT_REPORT_PARAMETER_OBJECT";
export const CURRENT_REPORT_OBJECT="CURRENT_REPORT_OBJECT";
export const SET_AUDIT_LIST_SEARCH_TEXT="SET_AUDIT_LIST_SEARCH_TEXT";
export const SET_LEVEL_GRID_SEARCH_ENABLED="SET_LEVEL_GRID_SEARCH_ENABLED";
export const SET_SELECTED_EMDR_AUDIT_LIST="SET_SELECTED_EMDR_AUDIT_LIST"
export const SET_AUDIT_LIST="SET_AUDIT_LIST";

export  const exportFormatForLongRunningReports = {
  showOtherSectionBorder: true,
  id: 'pnlExportFormatReportRadioGroup',
  type: 'radiogroup',
  title: 'Export Format For Long Running Reports',
  selected: 'PDF',
  selectedValue: 0,
  items: ['PDF', 'Word (.docx)']
};
const path = window.location.pathname;
const initialState = {
  isLoading: false,
  auditList: [],
  reportList:[],
  headerRangeFilterCount: path.includes('/emdrInbox')? 6 : 12,
  currentReportPromptObject:{},
  reportParameter:{},
  currentReportObject:{},
  auditListSearchText: '',
  isCaseLevelGridSearchEnabled: false,
  selectedeMDRAuditList:[],
  isAuditWithCasesFetched: false,
};

export default function (state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_REPORT_PARAMETER_POPUP:
    case TOGGLE_VIEW_REPORT_POPUP:
    case SET_HEADER_RANGE_FILTER_COUNT:
    case TOGGLE_AUDIT_LIST_ACTION_POPOVER:
    case TOGGLE_DOCUMENT_MANAGEMENT_POPUP:
    case SET_EXTERNAL_AUDIT_PROPERTIES:
    case SET_AUDIT_LIST_SEARCH_TEXT:
    case SET_LEVEL_GRID_SEARCH_ENABLED:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
      case SET_SELECTED_EMDR_AUDIT_LIST:
      return {   
        ...newState,          
        selectedeMDRAuditList:
          action.data.selectedeMDRAuditList,
      };
    case SET_AUDIT_DATAGRID_FILTER:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case CURRENT_REPORT_OBJECT:
      return {...state, currentReportObject: action.data}
    case CURRENT_REPORT_PARAMETER_OBJECT:
      return {...state, currentReportPromptObject: action.data}
    case SET_AUDIT_LIST:
      return {...state,  auditList: action.data.auditList}  
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:         
      if (isAsyncOperation(GET_REPORT_PACKAGE_LIST)(action)) {
        return { ...state, reportList: [] };
      }
      if (isAsyncComplete(GET_REPORT_PACKAGE_LIST)(action)) {
        const response = action.response;
        action.response?.forEach(element => {
          if(element.name?.toLowerCase() === 'audit appeal denial outcome summary'){
            element.name = 'Audit Appeal/Denial Outcome Summary';
          }
        });
        return { ...state, isLoading: false, reportList: response };
      }
      if (isAsyncOperation(GET_AUDIT_LIST)(action)) {
        return {
          ...state,
        };
      }
      if (isAsyncComplete(GET_AUDIT_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          auditList: response,
        };
      }
      return state;
    default:
      return state;
  }
}

export const setDataGridFilter = (auditListDataGridInstance) => (
  dispatch,
  getState
) => {
  const auditList = getState()["auditListReducer"].auditList;

  let eaAuditIds = auditList.map((item) => item.eaAuditId);
  if (Array.isArray(eaAuditIds) && eaAuditIds.length > 0) {
    auditListDataGridInstance.clearFilter();
    auditListDataGridInstance.filter((item) => {
      return eaAuditIds.includes(item.eaAuditId);
    });
  }
  dispatch({ type: HIDE_LOADER });
};
export const resetDataGridFilter = (
  isMyAudit,
  type,
  headerRangeFilterCount,
  doumentId
) => (dispatch, getState) => {
  refreshExternalAuditList(
    isMyAudit,
    headerRangeFilterCount,
    type,
    doumentId,
    null,
    dispatch
  );
  dispatch({
    type: SET_LEVEL_GRID_SEARCH_ENABLED,
    data: {
      auditListSearchText: "",
    },
  });
  dispatch({
    type: SET_LEVEL_GRID_SEARCH_ENABLED,
    data: {
      isAuditWithCasesFetched: false,
    },
  });
};
export const GetInitialHeaderRangeCount =(type)=>{
  if (type?.toUpperCase() === AUDIT_LIST_TYPE.EMDR_TYPE) {
    return 6;
  } else {
    return 12;
  }
}